/** Generate a simple unique ID for force elements and models */
let counter = 0;

export function generateId(prefix = "id"): string {
	counter += 1;
	const timestamp = Date.now().toString(36);
	const random = Math.random().toString(36).substring(2, 6);
	return `${prefix}-${timestamp}-${random}-${counter}`;
}
